import { render, staticRenderFns } from "./salaries.pug?vue&type=template&id=2f77e7e9&lang=pug&"
import script from "./salaries.js?vue&type=script&lang=js&"
export * from "./salaries.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f77e7e9')) {
      api.createRecord('2f77e7e9', component.options)
    } else {
      api.reload('2f77e7e9', component.options)
    }
    module.hot.accept("./salaries.pug?vue&type=template&id=2f77e7e9&lang=pug&", function () {
      api.rerender('2f77e7e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/salaries/index.vue"
export default component.exports